import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./tokens/flux.css";
import "./tokens/flux-dark.css";
import App from "./App";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
